import React from 'react';
import { Input as AntdInput } from 'antd';

const TextArea = (props) => {
  const { field, value } = props;
  const { config = {}, disabled } = field || {};
  return <AntdInput.TextArea disabled={disabled} value={value} {...config.inputProps} />;
};

export default TextArea;
